module.exports = __webpack_public_path__ + "static/media/logo-currencycloud.0bfd4c93.svg";